// extracted by mini-css-extract-plugin
export default {"post_list":"PostList_post_list__10ik7","card_description":"PostList_card_description__xKYFY"};